<template>
    <div>
        <v-card>
            <v-card-title class="subtitle-1 primary--text">
                APPROVE LOG
            </v-card-title>
            <v-card-text>
                <v-row v-for="(log, idx) in data_log" :key="idx">
                    <v-col cols="6">
                        <b
                            >{{ log.log_date }}
                            -
                            {{ log.log_name }}
                        </b>
                    </v-col>
                    <v-col cols="6">
                        {{ log.log_note }}
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import axios from "axios"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    props: ["emp_id"],
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },

    methods: {
        async get_data() {
            let send = {
                emp_id: this.emp_id,
            }
            await axios
                .post(url + "ot/approve-log/", send, this.tk)
                .then((response) => {
                    this.data_log = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            tk: null,
            data_log: [],
        }
    },
}
</script>
